<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.2679 6.16668C10.2679 5.52268 10.5964 5.00002 11.0012 5.00002L21.2667 5.00002C21.6715 5.00002 22 5.52268 22 6.16668C22 6.81068
            21.6715 7.33335 21.2667 7.33335L11.0012 7.33335C10.5964 7.33335 10.2679 6.81068 10.2679 6.16668ZM4.81836 8.71468L4.70807 8.81268L2.33937
            11.1904C1.92652 11.6052 1.88542 12.2595 2.24316 12.7222L2.33937 12.8319L4.70807 15.2095C5.02518 15.5282 5.49786 15.638 5.9241 15.4919C6.35034
            15.3459 6.65475 14.9699 6.70722 14.5247L6.71426 14.3882L6.71544 13.1667L20.8268 13.1667C21.4747 13.1667 22 12.6443 22 12C22 11.3557 21.4747
            10.8333 20.8268 10.8333L6.71544 10.8334L6.71543 9.63168C6.71489 9.37351 6.62824 9.12281 6.46906 8.91885L6.36699 8.80218C5.94687 8.38907 5.28338
            8.35108 4.81836 8.71352L4.81836 8.71468ZM11.0012 16.6667C10.5964 16.6667 10.2679 17.1894 10.2679 17.8334C10.2679 18.4774 10.5964 19 11.0012 19L21.2667
            19C21.6715 19 22 18.4773 22 17.8333C22 17.1893 21.6715 16.6667 21.2667 16.6667L11.0012 16.6667Z"
        />
    </svg>
</template>
